var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"failed"},[_c('img',{attrs:{"src":require("../assets/img/verify/shibai1.png"),"alt":""}}),_c('p',[_vm._v("内容加载失败")]),_c('p',[_vm._v("请稍后重试")]),_c('div',{on:{"click":_vm.handleClick}},[_vm._v("刷新")])])
}
var staticRenderFns = []

export { render, staticRenderFns }